import BodyText from "./BodyText";
import Box from "./Box";
import Button from "./Button";
import PropTypes from "prop-types";
import React from "react";
import { withTheme } from "styled-components";

function Checkbox({ checked, theme, onClick, children, error, name }) {
  return (
    <Box display="flex" cursor="pointer">
      <Button
        borderRadius="50%"
        borderStyle="solid"
        borderWidth="2px"
        borderColor={theme.colors.foreground}
        width={32}
        height={32}
        mr={20}
        onClick={onClick}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexShrink={0}
      >
        <Box
          backgroundColor={theme.colors.foreground}
          borderRadius="50%"
          width={22}
          height={22}
          opacity={checked ? "1" : "0"}
        ></Box>
      </Button>
      <BodyText
        pt="11px"
        dangerouslySetInnerHTML={{ __html: children }}
      ></BodyText>
    </Box>
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  error: PropTypes.bool,
};

export default withTheme(Checkbox);
